<form class="dob-form" [formGroup]="dateOfBirthForm">
  <mat-form-field appearance="fill" class="dob-form-field">
    <input
      placeholder="MM"
      class="mat-input-class"
      matInput
      formControlName="month"
      (keyup)="validateAndReturnDob()"
    />
  </mat-form-field>

  <mat-form-field appearance="fill" class="dob-form-field">
    <input
      placeholder="DD"
      class="mat-input-class"
      matInput
      formControlName="day"
      (keyup)="validateAndReturnDob()"
    />
  </mat-form-field>

  <mat-form-field appearance="fill" class="dob-form-field">
    <input
      placeholder="YYYY"
      class="mat-input-class"
      matInput
      formControlName="year"
      (keyup)="validateAndReturnDob()"
    />
  </mat-form-field>
</form>
